import hash from 'hash-sum';
import { compile, isCodeVueSfc, adaptCreateElement, concatenate, addScopedStyle } from 'vue-inbrowser-compiler';
import { parse } from '@vue/compiler-dom';
import { createCompilerError } from '@vue/compiler-core/dist/compiler-core.cjs';
import { parse as parse$1 } from 'acorn';
import { visit } from 'recast';
import has from 'lodash.has';
import 'prismjs';
import 'prismjs/components/prism-jsx.min';
import PrismEditor from 'vue-prism-editor';
import debounce from 'debounce';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = o[Symbol.iterator]();
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var ELEMENT = 1;
var SIMPLE_EXPRESSION = 4;
var INTERPOLATION = 5;
function checkTemplate ($options) {
  if (!$options.template) {
    return;
  }

  var ast;

  try {
    ast = parse($options.template);
  } catch (e) {
    throw createCompilerError(e.code);
  }

  traverse(ast, [function (templateAst) {
    if (templateAst.type === ELEMENT) {
      templateAst.props.forEach(function (attr) {
        var exp = attr.type !== SIMPLE_EXPRESSION && attr.exp ? attr.exp.content : undefined;

        if (!exp) {
          return;
        }

        try {
          checkExpression(exp, $options);
        } catch (e) {
          throw new VueLiveParseTemplateError(e.message, exp, e);
        }
      });
    } else if (templateAst.type === INTERPOLATION) {
      try {
        if (templateAst.content) {
          checkExpression(templateAst.content.content, $options);
        }
      } catch (e) {
        throw new VueLiveParseTemplateError(e.message, templateAst.content, e);
      }
    }
  }]);
}
function checkExpression(expression, $options) {
  // try and parse the expression
  var ast = parse$1("() => {".concat(expression, "}")); // identify all variables that would be undefined because not in the data object

  visit(ast, {
    visitIdentifier: function visitIdentifier(identifier) {
      var varName = identifier.value.name;

      if ((identifier.name === "expression" || identifier.name === "argument" || identifier.parentPath.name === "arguments") && (!$options || typeof $options.data !== "function" || !has($options.data(), varName) && !has($options.props, varName) && Array.isArray($options.props) && $options.props.indexOf(varName) === -1)) {
        throw new VueLiveUndefinedVariableError("Variable \"".concat(varName, "\" is not defined."), varName);
      }

      this.traverse(identifier);
    }
  });
}
function traverse(templateAst, handlers) {
  var traverseAstChildren = function traverseAstChildren(templateAst) {
    var children = templateAst.children;

    if (children) {
      var _iterator = _createForOfIteratorHelper(children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var childNode = _step.value;
          traverse(childNode, handlers);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  };

  handlers.forEach(function (handler) {
    handler(templateAst);
  });
  traverseAstChildren(templateAst);
}
function VueLiveUndefinedVariableError(message, varName) {
  this.message = message;
  this.varName = varName;
}
function VueLiveParseTemplateError(message, expression, subError) {
  this.message = message;
  this.expression = expression;
  this.subError = subError;
}

/**
 * evaluate es5 code in the browser
 * and return value if there s a return statement
 * @param {String} code the body of the funtion to execute
 * @param {Function} require the fake function require
 */
function evalInContext(code, require, adaptCreateElement, concatenate) {
  // eslint-disable-next-line no-new-func
  var func = new Function("require", "__pragma__", "__concatenate__", code);
  return func(require, adaptCreateElement, concatenate);
}

/**
 * Return module from a given map (like {app: require('app')}) or throw.
 */
function requireAtRuntime(requires, filepath) {
  requires = requires || {};

  if (!(filepath in requires)) {
    throw new Error("import or require() statements can be added only by setting it using the requires prop");
  }

  return requires[filepath];
}

var script = {
  name: "VueLivePreviewComponent",
  components: {},
  errorCaptured: function errorCaptured(err) {
    this.handleError(err);
  },
  props: {
    /**
     * code rendered
     */
    code: {
      type: String,
      required: true
    },

    /**
     * Hashtable of auto-registered components
     * @example { DatePicker: VueDatePicker }
     * @example { VueDatePicker }
     */
    components: {
      type: Object,
      default: function _default() {}
    },

    /**
     * Hashtable of modules available in require and import statements
     * in the code prop
     * @example { lodash: require("lodash") }
     * @example { moment: require("moment") }
     */
    requires: {
      type: Object,
      default: function _default() {}
    },
    jsx: {
      type: Boolean,
      default: false
    },

    /**
     * Outside data to the preview
     * @example { count: 1 }
     */
    dataScope: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      scope: this.generateScope(),
      previewedComponent: undefined,
      iteration: 0,
      error: false
    };
  },
  created: function created() {
    this.renderComponent(this.code.trim());
  },
  watch: {
    code: function code(value) {
      this.renderComponent(value.trim());
    }
  },
  methods: {
    /**
     * Generates the Scope Id attribute value. It will be added to each
     * tag if a style is applied to scope the style only to this example
     */
    generateScope: function generateScope() {
      return "v-xxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    },
    handleError: function handleError(e) {
      /**
       * Emitted every time the component rendered throws an error
       * Catches runtime and compilation errors
       * @event
       * @property { Error } - the error thrown
       */
      this.$emit("error", e);

      if (e.constructor === VueLiveParseTemplateError) {
        e.message = "Cannot parse template expression: ".concat(e.expression, "\n\n").concat(e.message);
      }

      this.error = e.message;
    },
    renderComponent: function renderComponent(code) {
      var _this = this;

      var options = {};
      var style;

      try {
        var renderedComponent = compile(code, this.jsx ? {
          jsx: "__pragma__(h)",
          objectAssign: "__concatenate__"
        } : {});
        style = renderedComponent.style;

        if (renderedComponent.script) {
          // if the compiled code contains a script it might be "just" a script
          // if so, change scheme used by editor
          this.$emit("detect-language", isCodeVueSfc(code) ? "vue" : "js"); // compile and execute the script
          // it can be:
          // - a script setting up variables => we set up the data property of renderedComponent
          // - a `new Vue()` script that will return a full config object

          var script = renderedComponent.script;
          options = evalInContext(script, function (filepath) {
            return requireAtRuntime(_this.requires, filepath);
          }, adaptCreateElement, concatenate) || {};

          if (this.dataScope) {
            var mergeData = _objectSpread2({}, options.data(), {}, this.dataScope);

            options.data = function () {
              return mergeData;
            };
          }
        }

        if (renderedComponent.template) {
          // if this is a pure template or if we are in hybrid vsg mode,
          // we need to set the template up.
          options.template = "<div>".concat(renderedComponent.template, "</div>");
        }
      } catch (e) {
        this.handleError(e);
        return;
      }

      try {
        checkTemplate(options);
      } catch (e) {
        this.handleError(e);
        return;
      }

      options.components = this.components;

      if (style) {
        // To add the scope id attribute to each item in the html
        // this way when we add the scoped style sheet it will be aplied
        options._scopeId = "data-".concat(this.scope);
        addScopedStyle(style, this.scope);
      }

      if (options.template || options.render) {
        this.previewedComponent = options;
        this.iteration = this.iteration + 1;
        this.error = false;
      } else {
        this.handleError({
          message: "[Vue Live] no template or render function specified, you might have an issue in your example"
        });
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

function createInjectorSSR(context) {
    if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
    }
    if (!context)
        return () => { };
    if (!('styles' in context)) {
        context._styles = context._styles || {};
        Object.defineProperty(context, 'styles', {
            enumerable: true,
            get: () => context._renderStyles(context._styles)
        });
        context._renderStyles = context._renderStyles || renderStyles;
    }
    return (id, style) => addStyle(id, style, context);
}
function addStyle(id, css, context) {
    const group = process.env.NODE_ENV === 'production' ? css.media || 'default' : id;
    const style = context._styles[group] || (context._styles[group] = { ids: [], css: '' });
    if (!style.ids.includes(id)) {
        style.media = css.media;
        style.ids.push(id);
        let code = css.source;
        if (process.env.NODE_ENV !== 'production' && css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    Buffer.from(unescape(encodeURIComponent(JSON.stringify(css.map)))).toString('base64') +
                    ' */';
        }
        style.css += code + '\n';
    }
}
function renderStyles(styles) {
    let css = '';
    for (const key in styles) {
        const style = styles[key];
        css +=
            '<style data-vue-ssr-id="' +
                Array.from(style.ids).join(' ') +
                '"' +
                (style.media ? ' media="' + style.media + '"' : '') +
                '>' +
                style.css +
                '</style>';
    }
    return css;
}

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.error
    ? _c(
        "pre",
        { class: _vm.$style.error },
        [_vm._ssrNode(_vm._ssrEscape(_vm._s(this.error)))],
        2
      )
    : _vm.previewedComponent
    ? _c(_vm.previewedComponent, {
        key: _vm.iteration,
        tag: "component",
        attrs: { id: _vm.scope }
      })
    : _vm._e()
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-3fd1eeb2_0", { source: "\n.src-error-3F1Q {\n  color: red;\n  text-align: left;\n  overflow: auto;\n  white-space: pre-wrap;\n}\n", map: {"version":3,"sources":["/home/travis/build/vue-styleguidist/vue-live/src/Preview.vue"],"names":[],"mappings":";AA0LA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AACA","file":"Preview.vue","sourcesContent":["<template>\n  <pre :class=\"$style.error\" v-if=\"error\">{{ this.error }}</pre>\n  <component\n    v-else-if=\"previewedComponent\"\n    :id=\"scope\"\n    :is=\"previewedComponent\"\n    :key=\"iteration\"\n  />\n</template>\n\n<script>\nimport {\n  compile as compileScript,\n  isCodeVueSfc,\n  addScopedStyle,\n  adaptCreateElement,\n  concatenate,\n} from \"vue-inbrowser-compiler\";\nimport checkTemplate, {\n  VueLiveParseTemplateError,\n} from \"./utils/checkTemplate\";\nimport evalInContext from \"./utils/evalInContext\";\nimport requireAtRuntime from \"./utils/requireAtRuntime\";\n\nexport default {\n  name: \"VueLivePreviewComponent\",\n  components: {},\n  errorCaptured(err) {\n    this.handleError(err);\n  },\n  props: {\n    /**\n     * code rendered\n     */\n    code: {\n      type: String,\n      required: true,\n    },\n    /**\n     * Hashtable of auto-registered components\n     * @example { DatePicker: VueDatePicker }\n     * @example { VueDatePicker }\n     */\n    components: {\n      type: Object,\n      default: () => {},\n    },\n    /**\n     * Hashtable of modules available in require and import statements\n     * in the code prop\n     * @example { lodash: require(\"lodash\") }\n     * @example { moment: require(\"moment\") }\n     */\n    requires: {\n      type: Object,\n      default: () => {},\n    },\n    jsx: {\n      type: Boolean,\n      default: false,\n    },\n    /**\n     * Outside data to the preview\n     * @example { count: 1 }\n     */\n    dataScope: {\n      type: Object,\n      default: () => {},\n    },\n  },\n  data() {\n    return {\n      scope: this.generateScope(),\n      previewedComponent: undefined,\n      iteration: 0,\n      error: false,\n    };\n  },\n  created() {\n    this.renderComponent(this.code.trim());\n  },\n  watch: {\n    code(value) {\n      this.renderComponent(value.trim());\n    },\n  },\n  methods: {\n    /**\n     * Generates the Scope Id attribute value. It will be added to each\n     * tag if a style is applied to scope the style only to this example\n     */\n    generateScope() {\n      return \"v-xxxxxxxx\".replace(/[xy]/g, (c) => {\n        const r = (Math.random() * 16) | 0;\n        const v = c === \"x\" ? r : (r & 0x3) | 0x8;\n        return v.toString(16);\n      });\n    },\n    handleError(e) {\n      /**\n       * Emitted every time the component rendered throws an error\n       * Catches runtime and compilation errors\n       * @event\n       * @property { Error } - the error thrown\n       */\n      this.$emit(\"error\", e);\n      if (e.constructor === VueLiveParseTemplateError) {\n        e.message = `Cannot parse template expression: ${e.expression}\\n\\n${e.message}`;\n      }\n      this.error = e.message;\n    },\n    renderComponent(code) {\n      let options = {};\n      let style;\n      try {\n        const renderedComponent = compileScript(\n          code,\n          this.jsx\n            ? { jsx: \"__pragma__(h)\", objectAssign: \"__concatenate__\" }\n            : {}\n        );\n        style = renderedComponent.style;\n        if (renderedComponent.script) {\n          // if the compiled code contains a script it might be \"just\" a script\n          // if so, change scheme used by editor\n          this.$emit(\"detect-language\", isCodeVueSfc(code) ? \"vue\" : \"js\");\n\n          // compile and execute the script\n          // it can be:\n          // - a script setting up variables => we set up the data property of renderedComponent\n          // - a `new Vue()` script that will return a full config object\n          const script = renderedComponent.script;\n          options =\n            evalInContext(\n              script,\n              (filepath) => requireAtRuntime(this.requires, filepath),\n              adaptCreateElement,\n              concatenate\n            ) || {};\n\n          if (this.dataScope) {\n            const mergeData = { ...options.data(), ...this.dataScope };\n            options.data = () => mergeData;\n          }\n        }\n        if (renderedComponent.template) {\n          // if this is a pure template or if we are in hybrid vsg mode,\n          // we need to set the template up.\n          options.template = `<div>${renderedComponent.template}</div>`;\n        }\n      } catch (e) {\n        this.handleError(e);\n        return;\n      }\n\n      try {\n        checkTemplate(options);\n      } catch (e) {\n        this.handleError(e);\n        return;\n      }\n\n      options.components = this.components;\n      if (style) {\n        // To add the scope id attribute to each item in the html\n        // this way when we add the scoped style sheet it will be aplied\n        options._scopeId = `data-${this.scope}`;\n        addScopedStyle(style, this.scope);\n      }\n\n      if (options.template || options.render) {\n        this.previewedComponent = options;\n        this.iteration = this.iteration + 1;\n        this.error = false;\n      } else {\n        this.handleError({\n          message:\n            \"[Vue Live] no template or render function specified, you might have an issue in your example\",\n        });\n      }\n    },\n  },\n};\n</script>\n\n<style module>\n.error {\n  color: red;\n  text-align: left;\n  overflow: auto;\n  white-space: pre-wrap;\n}\n</style>\n"]}, media: undefined });
Object.defineProperty(this, "$style", { value: {"error":"src-error-3F1Q"} });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = "data-v-3fd1eeb2";
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    createInjectorSSR,
    undefined
  );

//
var UPDATE_DELAY = 300;
var script$1 = {
  name: 'VueLiveEditor',
  components: {
    PrismEditor: PrismEditor
  },
  props: {
    code: {
      type: String,
      required: true
    },
    delay: {
      type: Number,
      default: UPDATE_DELAY
    },
    editorProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    prismLang: {
      type: String,
      default: 'html'
    }
  },
  data: function data() {
    return {
      updatePreview: function updatePreview() {},

      /**
       * this data only gets changed when changing language.
       * it allows for copy and pasting without having the code
       * editor repainted every keystroke
       */
      stableCode: this.code
    };
  },
  watch: {
    code: function code(value) {
      this.updatePreview(value);
    }
  },
  created: function created() {
    var _this = this;

    this.updatePreview = debounce(function (value) {
      _this.stableCode = value;

      _this.$emit('change', value);
    }, this.delay);
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "PrismEditor",
    _vm._b(
      {
        attrs: { language: _vm.prismLang },
        on: { change: _vm.updatePreview },
        model: {
          value: _vm.stableCode,
          callback: function($$v) {
            _vm.stableCode = $$v;
          },
          expression: "stableCode"
        }
      },
      "PrismEditor",
      _vm.editorProps,
      false
    )
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = "data-v-6445b2c4";
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

/* script */

/* template */
var __vue_render__$2 = function(_h, _vm) {
  var _c = _vm._c;
  return _c(
    "div",
    { staticClass: "vue-live-container", staticStyle: { display: "flex" } },
    [
      _vm._ssrNode('<div style="width:50%;">', "</div>", [_vm._t("editor")], 2),
      _vm._ssrNode(" "),
      _vm._ssrNode(
        '<div style="background-color:white;width:50%;">',
        "</div>",
        [_vm._t("preview")],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = "data-v-79524fda";
  /* functional template */
  const __vue_is_functional_template__$2 = true;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    {},
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

//
var LANG_TO_PRISM = {
  vue: "html",
  js: "jsx"
};
var UPDATE_DELAY$1 = 300;
var script$2 = {
  name: "VueLivePreview",
  components: {
    Preview: __vue_component__,
    Editor: __vue_component__$1
  },
  props: {
    /**
     * code rendered in the preview and the editor
     */
    code: {
      type: String,
      required: true
    },

    /**
     * Layout vue component with 2 slots named `editor` & `preview`
     */
    layout: {
      type: Object,
      default: undefined
    },

    /**
     * Hashtable of auto-registered components
     * @example { DatePicker: VueDatePicker }
     * @example { VueDatePicker }
     */
    components: {
      type: Object,
      default: function _default() {}
    },

    /**
     * Hashtable of modules available in require and import statements
     * in the Preview component
     * @example { lodash: require("lodash") }
     * @example { moment: require("moment") }
     */
    requires: {
      type: Object,
      default: function _default() {}
    },

    /**
     * Time in ms debouncing updates to the preview
     */
    delay: {
      type: Number,
      default: UPDATE_DELAY$1
    },

    /**
     * Do the code contain JSX rendered functions
     */
    jsx: {
      type: Boolean,
      default: false
    },

    /**
     * These props will be passed as a spreat to your layout
     * They can be used to change the style
     */
    layoutProps: {
      type: Object,
      default: undefined
    },

    /**
     * Props of vue-prism-editor
     * @example { lineNumbers: true }
     * @see https://github.com/koca/vue-prism-editor
     */
    editorProps: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    /**
     * Outside data to the preview
     * @example { count: 1 }
     */
    dataScope: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      model: this.code,
      lang: "vue",
      prismLang: "html",
      VueLiveDefaultLayout: __vue_component__$2,

      /**
       * this data only gets changed when changing language.
       * it allows for copy and pasting without having the code
       * editor repainted every keystroke
       */
      stableCode: this.code
    };
  },
  computed: {
    codeKey: function codeKey() {
      return hash(this.model);
    }
  },
  watch: {
    code: function code(newCode) {
      this.stableCode = newCode;
      this.model = newCode;
    }
  },
  methods: {
    updatePreview: function updatePreview(code) {
      this.stableCode = code;
      this.model = code;
      this.$emit("change", code);
    },
    switchLanguage: function switchLanguage(newLang) {
      this.lang = newLang;
      var newPrismLang = LANG_TO_PRISM[newLang];

      if (this.prismLang !== newPrismLang) {
        this.prismLang = newPrismLang;
        this.stableCode = this.model;
      }
    }
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    _vm.layout ? _vm.layout : _vm.VueLiveDefaultLayout,
    _vm._b(
      {
        tag: "component",
        attrs: {
          code: _vm.stableCode,
          language: _vm.lang,
          prismLang: _vm.prismLang,
          requires: _vm.requires,
          "data-scope": _vm.dataScope,
          components: _vm.components
        },
        scopedSlots: _vm._u([
          {
            key: "editor",
            fn: function() {
              return [
                _c("Editor", {
                  attrs: {
                    code: _vm.stableCode,
                    delay: _vm.delay,
                    "prism-lang": _vm.prismLang,
                    "editor-props": _vm.editorProps
                  },
                  on: { change: _vm.updatePreview }
                })
              ]
            },
            proxy: true
          },
          {
            key: "preview",
            fn: function() {
              return [
                _c("Preview", {
                  key: _vm.codeKey,
                  attrs: {
                    code: _vm.model,
                    components: _vm.components,
                    requires: _vm.requires,
                    jsx: _vm.jsx,
                    "data-scope": _vm.dataScope
                  },
                  on: {
                    "detect-language": _vm.switchLanguage,
                    error: function(e) {
                      return _vm.$emit("error", e)
                    }
                  }
                })
              ]
            },
            proxy: true
          }
        ])
      },
      "component",
      _vm.layoutProps,
      false
    )
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = "data-v-0e580460";
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$2,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

function install(Vue) {
  Vue.component("VueLive", __vue_component__$3);
  Vue.component("VueLivePreview", __vue_component__);
  Vue.component("VueLiveEditor", __vue_component__$1);
} // Export the library as a plugin


var main = {
  install: install
};

export default main;
export { __vue_component__$3 as VueLive, __vue_component__$1 as VueLiveEditor, __vue_component__ as VueLivePreview };
